import type { PropsWithChildren } from "react";

import { FormControl, FormLabel } from "@mui/material";

type FieldLayoutElementProps = PropsWithChildren<{
  fieldName: string;
  fullWidth?: boolean;
  label?: string;
  required?: boolean;
}>;

export const ElementLayout = ({
  children,
  fieldName,
  fullWidth,
  label,
  required,
}: FieldLayoutElementProps) => {
  return (
    <FormControl fullWidth={fullWidth}>
      {label ? (
        <FormLabel htmlFor={fieldName}>
          {label}
          {required ? " *" : ""}
        </FormLabel>
      ) : null}
      {children}
    </FormControl>
  );
};
